import { FC, useMemo } from 'react';
import { UnpinGreyIcon } from '../../../svg/custom.svg';
import { Box, IconButton, styled } from '@mui/material';
import { FormTextEditor, FormTextField } from '../form';

export const PinnedText: FC<IPinnedTextProps> = ({
  name,
  isPinned,
  handleUnpinClick,
  type = 'text',
}) => {
  const defaultFontSize = useMemo(() => ({ fontSize: 16 }), []);

  return (
    <>
      {isPinned && (
        <SBox width='300px'>
          <SUnpinButton onClick={handleUnpinClick} size='small'>
            <UnpinGreyIcon />
          </SUnpinButton>
          {type === 'editor' && (
            <FormTextEditor
              name={name}
              defaultFormat={defaultFontSize}
              minHeight={106}
              disabled={true}
            />
          )}
          {type === 'text' && (
            <FormTextField
              name={name}
              disabled={true}
              multiline={true}
              maxRows={4}
              minRows={4}
              color='warning'
            />
          )}
        </SBox>
      )}
    </>
  );
};

const SBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  ' & .remirror-theme .remirror-editor-wrapper': {
    padding: '0px',
    '& div': {
      maxHeight: '108px',
      overflowX: 'hidden',
      padding: '8.5px 25px 8.5px 14px',
      color: theme.palette.black.main,
      '& p': {
        whiteSpace: 'pre-wrap',
      },
    },

    '& div:hover': {
      boxShadow: '0px 0px 0px 0.06em #bdbdbd',
    },
  },

  '& textarea.Mui-disabled': {
    color: theme.palette.black.main,
    WebkitTextFillColor: theme.palette.black.main,
    paddingRight: '14px',
  },

  ' & .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #bdbdbd !important',
    marginTop: '-1px',
    maxHeight: '113px',
  },
}));

const SUnpinButton = styled(IconButton)({
  position: 'absolute',
  top: 5,
  right: 5,
  zIndex: 10,
  '& svg': {
    width: 19,
    height: 22,
  },
});

interface IPinnedTextProps {
  name: string;
  isPinned: boolean;
  handleUnpinClick: () => void;
  type?: 'text' | 'editor';
}
